<template>
    <div class="columns" style="padding-top: 20px;">
        <div class="column">
            <div class="tabs is-centered">
                <ul>
                    <router-link tag="li"
                                 active-class="is-active"
                                 exact
                                 to="/auctions">
                        <a>Brand</a>
                    </router-link>
                    <router-link tag="li"
                                 active-class="is-active"
                                 to="/auctions/models/" @click.native="followModelsLink()">
                        <a>Model</a>
                    </router-link>
                    <router-link tag="li"
                                 active-class="is-active"
                                 to="/auctions/locations">
                        <a>Auction & Date</a>
                    </router-link>
                    <router-link tag="li"
                                 active-class="is-active"
                                 to="/auctions/advance">
                        <a>Advance</a>
                    </router-link>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            getModelsUrl: function() {
                if ( this.$store.getters.getQueryCompanyId ) {
                    return this.$store.getters.getQueryCompanyId
                }
            }
        },
        methods: {
            followModelsLink: function () {
                if ( this.$store.getters.getQueryCompanyId ) {
                    this.$router.push({ path: '/auctions/models/' + this.$store.getters.getQueryCompanyId })
                } else {
                    this.$router.push({ path: '/auctions/models/' })
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/AuctionNavigation.vue